/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPhoneOn = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14.634 15.504a18.427 18.427 0 0 1-1.848 1.525l-3.72-3.721-6.304.9v5.525l.293.293c2.193 2.193 6.265 1.684 10.225-.91a20.315 20.315 0 0 0 3.21-2.626 20.315 20.315 0 0 0 2.625-3.21c2.595-3.96 3.104-8.032.91-10.225l-.292-.293h-5.525l-.9 6.303 3.72 3.72a18.653 18.653 0 0 1-1.952 2.29zm-3.585 2.616c-2.615 1.412-4.996 1.657-6.287.739v-2.916l3.596-.514zm7.071-7.07-2.69-2.692.513-3.596h2.916c.918 1.29.673 3.672-.739 6.287z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPhoneOn as PhoneOn };
